import { render, staticRenderFns } from "./MultiButtonDesign.vue?vue&type=template&id=cbdc4aa0&"
import script from "./MultiButtonDesign.vue?vue&type=script&lang=ts&"
export * from "./MultiButtonDesign.vue?vue&type=script&lang=ts&"
import style0 from "./MultiButtonDesign.vue?vue&type=style&index=0&id=cbdc4aa0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports